import { render, staticRenderFns } from "./staff-exit.vue?vue&type=template&id=fa875086&scoped=true&"
import script from "./staff-exit.vue?vue&type=script&lang=js&"
export * from "./staff-exit.vue?vue&type=script&lang=js&"
import style0 from "./staff-exit.vue?vue&type=style&index=0&id=fa875086&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa875086",
  null
  
)

export default component.exports